window.blur = () => {
    if (document.activeElement !== document.body) {
        document.activeElement.blur();
    }
}
